import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { isEmpty } from 'lodash';
import { Subject } from 'rxjs';
import { DialogActionsEnum, IDialogTrigger } from '../../../dialog/dialog.data';
import { DialogService } from '../../../dialog/dialog.service';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { Document } from '../../../document-data/document.model';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { filter, takeUntil } from 'rxjs/operators';

export const DIALOG_TYPE = 'pdf-rerender';

export interface IPdfRendererDialogData {
  documentType: DocumentTypesEnum;
  documentNumber: string;
  document: Document;
}

@Component({
  selector: 'app-pdf-rerender-dialog',
  templateUrl: './pdf-rerender-dialog.component.html',
  styleUrls: ['./pdf-rerender-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfRerenderDialogComponent implements OnInit, OnDestroy {
  @Input() documentType: DocumentTypesEnum;
  @Input() documentNumber: string;
  @Input() document: Document;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  onReRenderPdf: EventEmitter<Document> = new EventEmitter<Document>();

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  dialogType: string;
  trackingObject: ITrackingObject;
  generateNewPdfAction: ITrackingAction;
  pdfNotFoundIcon: IIcon;

  constructor(
    private _dialogService: DialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.pdf_generate
    );
    this.generateNewPdfAction = this._trackingActionBuilder.buildButtonTapped(
      'generate_invoice',
      this.trackingScreenName
    );
    this.pdfNotFoundIcon = {
      name: 'pdf-not-found',
      size: IconSizesEnum.custom,
    };

    this._dialogService.dialogTriggers$
      .pipe(
        filter(
          ({ type, action }: IDialogTrigger) =>
            type === this.dialogType && action === DialogActionsEnum.open
        ),
        takeUntil(this._destroyed)
      )
      .subscribe(({ data }: IDialogTrigger) => {
        if (!isEmpty(data)) {
          const dialogData: IPdfRendererDialogData = data;

          if (dialogData.documentType) {
            this.documentType = dialogData.documentType;
          }

          if (dialogData.document) {
            this.document = dialogData.document;
          }

          if (dialogData.documentNumber) {
            this.documentNumber = dialogData.documentNumber;
          }

          this._changeDetectorRef.markForCheck();
          this._changeDetectorRef.detectChanges();
        }
      });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
